/**
 * Notification Service
 * Handles all notification-related API calls
 */
import api from './api';

const NotificationService = {
  /**
   * Get all notifications for the current user
   * @returns {Promise<Array>} Array of notifications
   */
  async getUserNotifications() {
    try {
      const response = await api.get('/api/notifications/user');
      return response;
    } catch (error) {
      console.error('Failed to fetch user notifications:', error);
      throw error;
    }
  },

  /**
   * Get all unread notifications for the current user
   * @returns {Promise<Array>} Array of unread notifications
   */
  async getUnreadNotifications() {
    try {
      const response = await api.get('/api/notifications/user/unread');
      return response;
    } catch (error) {
      console.error('Failed to fetch unread notifications:', error);
      throw error;
    }
  },

  /**
   * Mark a specific notification as read
   * @param {string} notificationId - The ID of the notification to mark as read
   * @returns {Promise<any>} Response data
   */
  async markAsRead(notificationId) {
    try {
      const response = await api.patch(`/api/notifications/${notificationId}/read`);
      return response;
    } catch (error) {
      console.error(`Failed to mark notification ${notificationId} as read:`, error);
      throw error;
    }
  },

  /**
   * Mark all notifications as read for the current user
   * @returns {Promise<any>} Response data
   */
  async markAllAsRead() {
    try {
      const response = await api.patch('/api/notifications/user/mark-all-read');
      return response;
    } catch (error) {
      console.error('Failed to mark all notifications as read:', error);
      throw error;
    }
  }
};

export default NotificationService;
